module.exports = __webpack_public_path__ + "assets/1f063a98feb0342a72db74e461565671.png";